export const API_URL = 'https://backend-dot-getraenke-app-2023.ew.r.appspot.com';
